import React from 'react'
import { Label } from '@entur/typography'
import { colors, space } from '@entur/tokens'
import { Tooltip } from '@entur/tooltip'
import { Badge } from '@entur/layout'
import { ValidationFormField } from '../../utils/form-utils'
import { useEmployee } from '../../contexts/employee-context'

type EmployeePercentageElementProps = {
  field?: ValidationFormField<string>
  isLast?: boolean
}
export const EmployeePercentageElement: React.FC<EmployeePercentageElementProps> = ({ field, isLast }) => {
  const { employee } = useEmployee()
  const margin = isLast ? 0 : space.large

  const hasDraftChanges = employee?.draftEmployee && (field?.draftValue || '') !== (field?.value || '')

  return (
    <div style={{ marginBottom: margin }}>
      {hasDraftChanges && (
        <Tooltip content={`Nåværende verdi: ${field?.displayValue || field?.value || 'ingen'}`} placement="top">
          <div>
            <Label>{field?.displayName}</Label>{' '}
            <div style={{ display: 'inline-block' }}>
              {field?.draftValue ? (
                <span style={{ borderBottom: `2px dotted ${colors.validation.mintContrast}` }}>
                  {field.draftValue}
                </span>
              ) : (
                <span
                  style={{
                    borderBottom: `2px dotted ${colors.validation.mintContrast}`,
                    width: '15px',
                    display: 'inline-block',
                  }}
                >
                  &nbsp;
                </span>
              )}{' '}
              <Badge variant="success" style={{ display: 'inline', marginLeft: space.extraSmall2 }}>
                NY
              </Badge>
            </div>
          </div>
        </Tooltip>
      )}
      {!hasDraftChanges && (
        <>
          <Label>{field?.displayName}</Label>
          <span>&emsp; {field?.value}</span>
        </>
      )}
    </div>
  )
}
